module.exports = __webpack_public_path__ + "media/customizations/pecansquarelife/back-ba14d61ecf2890c42678feccbd5a0cc7.jpg";